/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.GiftCardIntegration {
    angular.module("meevo.plugins.giftCardIntegration", []);
}